import { render, staticRenderFns } from "./AvatarGroupTable.vue?vue&type=template&id=11efed86&scoped=true"
import script from "./AvatarGroupTable.vue?vue&type=script&lang=js"
export * from "./AvatarGroupTable.vue?vue&type=script&lang=js"
import style0 from "./AvatarGroupTable.vue?vue&type=style&index=0&id=11efed86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11efed86",
  null
  
)

export default component.exports